import React from "react";
import HeroSection from "../components/Home/HeroSection";
import ServicesSection from "../components/Home/ServicesSection";
import Products from "../components/Home/Products";
import Testimony from "../components/Home/Testimony";
import FAQ from "../components/Home/FAQ";
import Notice from "../components/Home/Notice";

function Home() {
  return (
    <main className="relative bg-backgroundColor text-textColor">
      <HeroSection />
      <ServicesSection />
      <Products />
      <Testimony />
      <FAQ />
      <Notice />
    </main>
  );
}

export default Home;
